import {useEffect} from 'react'
import {useAuth} from '../../../context/auth/Context'
import {authAPI} from '../../../api'
import {useNavigate} from 'react-router-dom'
import { SplashLogo } from '../../../components/Logo'

export function SignOut() {

  const {signout} = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    authAPI.signOut().then(() => {
      signout()
      navigate('/')
    })
  }, [signout, navigate])

  return <SplashLogo/>
}
